export default "__VITE_ASSET__BIryZ9$8__"